import styled from '@emotion/styled';

import { ButtonLink } from '../Link/Link';

const CompanyMobileLogo = () => {
  return (
    <ButtonLink to='/'>
      <Container>
        <Img src='/static/img/logirate-mobile-logo.png' alt='Company' />
      </Container>
    </ButtonLink>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.12rem;
  font-weight: 500;
  color: black;
  width: fit-content;
`;

const Img = styled.img`
  width: 119px;
`;

export default CompanyMobileLogo;
